import {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import {connect, useDispatch} from "react-redux";
import validator from 'validator';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import DocumentMeta from "react-document-meta";

import Background from "../partials/Background";
import {socialRegisterAction, loadingToggleAction, loginAction, resetErrorMessage} from "../../Store/actions/AuthActions";
import React from "react";
import { PopupMessage } from "../../Components/utils";

import {
    isMobile
 } from "react-device-detect";

 import ReactGA from "react-ga";

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;

const meta = {
    title: 'Login',
    description: 'We are pleased to see you again.',
    canonical: `${process.env.REACT_APP_URL}/login`,
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'react,meta,document,html,tags'
        }
    } 
}


function Login(props) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [IsMobile, setIM] = useState(isMobile);
    const [errorMsg, setEM] = useState("");
    

    let errorsObj = {email: '', password: ''};
    const [errors, setErrors] = useState(errorsObj);

    ReactGA.event({category: "Navigation", action: "Visit Login Page", label: "Login"});

    const dispatch = useDispatch();

    useEffect(() => {
        setEM("");
      }, []);

    function onLogin(e) {
        e.preventDefault();
        ReactGA.event({category: "Action", action: "Set Login", label: "Login"});
        let error = false;
        const errorObj = {...errorsObj};
        if (email === '') {
            errorObj.email = 'Email is required';
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = 'Please enter valid email address';
            error = true;
        }
        if (password === '') {
            errorObj.password = 'Password is required';
            error = true;
        }

        setErrors(errorObj);

        if (error) return;
        dispatch(loadingToggleAction(true));

        setLoading(true);

        dispatch(loginAction(email, password, props.history, true, LoginError));
        
    }

    function LoginError(error){
        if(error != ""){
            setEM(error);
        }
        setLoading(false);
    }

    function closeErrorPopup(){
        setEM("");
    }

    function responseGoogle(data) {
        if (data.profileObj) {
            let obj = {
                socialId: data.profileObj.googleId,
                imageUrl: data.profileObj.imageUrl,
                email: data.profileObj.email,
                name: data.profileObj.name,
                social: 'Google'
            };
            setLoading(true);
            dispatch(socialRegisterAction(obj, props.history, true, null));
        }
    }

    function responseFacebook(data) {
        if (data.email) {
            let obj = {
                socialId: data.id,
                imageUrl: data.picture.data.url,
                email: data.email,
                name: data.name,
                social: 'Facebook'
            };
            setLoading(true);
            dispatch(socialRegisterAction(obj, props.history, true, null));
        }
    }

    return (
        <>
            {loading && (
                <div className="loading">
                    <img src="/images/menubar-navbar-desktop/logo.png" alt="loader" className="loader-img"/>
                </div>
            )}
            <DocumentMeta {...meta} />
            <section id="pet-content" className={`pet-content dayin content-area`}>
                <Background type="home-page"/>
                {/*errorMsg != "" ? 
                    <PopupMessage 
                    title="Error" 
                    subTitle="Account Not Found" 
                    bodyText={errorMsg}
                    closeFunction={closeErrorPopup}
                    /> :
                <></>
            */}
                
                <div className={`pet-creationname petregistrationpage ${IsMobile ? "mobile-padding" : ""}`}>
                    <div className={`container-fluid thankyoupagecontent loginpagecontentarea `}>
                        <div className={`row`}>
                            <div className={`col col-12 col-xs-12 right-content-area formarea thankyoupage loginpagecontent`}>
                                <div className="wizard thankyoucontentarrea mt-7">
                                    <h2 className="float-left w-100 text-center text-dark2 nametxt mt-7 mb-0">Welcome
                                        Back</h2>
                                    <h4 className="float-left w-100 text-center text-dark2 mb-4">We are pleased to see you
                                        again, login with</h4>
                                    <div className="d-flex justify-content-center float-left w-100 w-100 mt-3">
                                        <div>
                                            <FacebookLogin
                                                isMobile={false}
                                                appId={facebookAppId}
                                                autoLoad={false}
                                                fields="name,email,picture"
                                                onClick={() => {
                                                    console.log('click')
                                                }}
                                                callback={responseFacebook}/>
                                        </div>
                                        {/*<div className="col rightbtn-google">
                                            <GoogleLogin
                                                clientId={googleClientId}
                                                buttonText="Login"
                                                onSuccess={responseGoogle}
                                                onFailure={responseGoogle}
                                                cookiePolicy={'single_host_origin'}
                                            />
                                            </div>*/}
                                    </div>
                                    <h4 className="float-left w-100 text-center text-dark2 mt-1">or your email address</h4>
                                    <div className="float-left w-100 inputform mt-2 mb-1">
                                        <input type="text" className="text" placeholder="Email" value={email}
                                            onChange={(e) => setEmail(e.target.value)}/>
                                        {errors.email && <div className="text-danger">{errors.email}</div>}
                                    </div>
                                    <div className="float-left w-100 inputform mt-2 mb-1">
                                        <input type="password" className="text" placeholder="Password" value={password}
                                            onChange={(e) => setPassword(e.target.value)}/>
                                        {errors.password && <div className="text-danger">{errors.password}</div>}
                                    </div>
                                    <h4 className="float-left w-100 text-center text-dark2 mt-0">
                                        <Link to={{pathname: '/forgot-password'}}
                                            className="text-dark2 text-decoration-underline">Forgot
                                            Password?</Link>
                                    </h4>
                                    <h4 className="float-left w-100 text-center text-dark2 mt-4">Don't have an account?
                                        <Link className="text-dark2 text-decoration-underline" to={{pathname: '/register'}}>Click
                                            to sign up now</Link>
                                    </h4>

                                    {errorMsg && (
                                        <div className="col-12 float-left w-100 mt-4">
                                            <div className="alert alert-danger">{errorMsg}</div>
                                        </div>
                                    )}
                                    
                                    <div className="col-12 float-left w-100 text-center mt-4 wizsubbtn centerbox">
                                        {!props.showLoading && (
                                            <button type="button" onClick={onLogin} className="default-btn next-step">
                                                <img src="/images/button-design/Button-V4.png" alt="button"
                                                    className="img-fluid"/>
                                                <span className="col-12 float-left w-100 subnxttxt">Log In</span>
                                            </button>
                                        )}
                                        {props.showLoading && (
                                            <button type="button" className="default-btn next-step"
                                                    style={{opacity: '0.7'}}>
                                                <img src="/images/button-design/Button-V4.png" alt="button"
                                                    className="img-fluid"/>
                                                <span className="col-12 float-left w-100 subnxttxt">Log In</span>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        errorMessage: state.auth.errorMessage,
        successMessage: state.auth.successMessage,
        showLoading: state.auth.showLoading,
    };
};

export default connect(mapStateToProps)(Login);